module.exports = {"id":"215064","name":"Julio Furch","rating":"73","photo":"./data/images/photos/2/215064.png","club":{"name":"Santos Laguna","logo":"./data/images/clubs/SantosLaguna.png"},"positions":["BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JulioFurch0.json
// module id = 2251
// module chunks = 0